import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  inputPlaceholder: {},
  rightContainer: {},
  leftContainer: {},
  viewFilter: {
    width: "220px",
    paddingRight: "30px",
  },
  groupFilter: {
    width: "220px",
  },
  filterDropdownListContainer: {
    height: 300,
    padding: 5,
    margin: -5,
    overflowX: "hidden",
    overflowY: "auto",
  },
}));

export default useStyles;
